import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Invoice } from '../models/invoice';
import { environment } from '../../environments/environment';
import { InvoiceStatus } from '../models/invoice-status';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private http: HttpClient) { }

  public getInvoices() : Observable<Invoice[]> {
    return this.http.get<Invoice[]>(`${environment.API_URL}/invoices`);
  }

  public getInvoice(id: number) : Observable<Invoice> {
    return this.http.get<Invoice>(`${environment.API_URL}/invoices/${id}`);
  }

  public getStatuses() : Observable<InvoiceStatus[]> {
    return this.http.get<InvoiceStatus[]>(`${environment.API_URL}/invoices/statuses`);
  }

  public createInvoice(invoice: Invoice) : Observable<Invoice> {
    return this.http.post<Invoice>(`${environment.API_URL}/invoices/create`, invoice);
  }

  public updateInvoice(invoice: Invoice) : Observable<Invoice> {
    return this.http.post<Invoice>(`${environment.API_URL}/invoices/update`, invoice);
  }

  public deleteInvoice(id: number) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/invoices/delete`, {id: id});
  }

  public getInvoicePdf(id: number, lang: string) : Observable<ArrayBuffer>{
    return this.http.post(`${environment.API_URL}/invoices/pdf`, {id: id, lang: lang}, {responseType: 'arraybuffer'});
  }

  public getCurrentInvoiceNumber(year: number) : Observable<any> {
    return this.http.get(`${environment.API_URL}/invoices/number/${year}`);
  }

}
